import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';
import { IndustryDrawerAction } from '../../components/ListViewCustomComponents';
import { Industry } from '../../models/stack9/Industry';

const Drawer = IndustryDrawerAction.default;

type Props = {
  countrySetupId: number;
  initialValues?: Partial<Industry>;
};
const IndustriesInfo = ({ countrySetupId, initialValues }: Props) => {
  const columns: ColumnConfiguration[] = [
    {
      label: 'Code',
      field: 'code',
      renderAs: ColumnConfigurationRenderAs.CustomComponent,
      value: '{{code}}',
      options: {
        customComponentName: 'IndustryDrawerAction',
      },
    },
    {
      label: 'Name',
      field: 'name',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{name}}',
    },
    {
      label: 'Is active',
      field: 'is_active',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{is_active}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
  ];

  return (
    <ListTable
      queryVars={{ countrySetupId }}
      columns={columns}
      title="Industries"
      queryName="getindustrieslistbycountrysetup"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Drawer row={{ ...initialValues }} />
      </div>
    </ListTable>
  );
};

export default IndustriesInfo;
